import { ArbContactInfoDto } from './arb-contact-info.dto';

export interface ArbReadDto {
  ARBID: number;
  SubscriptionKey: string;
  Last4Digits: string;
  CCType: string;
  PaymentTypeID: number;
  ProfileID: number;
  Inactive: boolean;
  CC_ContactInfoID: number;
  AmountPerCycle: number;
  ExpireMonth: number;
  ExpireYear: number;
  BillingID: number;
  ItemNum: number;
  RevenueItem: string;
  Descr: string;
  ContactInfo: ArbContactInfoDto;
  BillingCycle: BillingCycleEnum;
  CardType: CardTypeEnum;
}

export enum BillingCycleEnum {
  None = 0,
  Monthly = 1,
  Quarterly = 2,
  HalfYearly = 3,
  Yearly = 4,
}

export enum CardTypeEnum {
  None = 0,
  Visa = 1,
  Mastercard = 2,
  Amex = 3,
  Discover = 4,
}
